import { type ProfileResponse } from "@vega-api/generated/types/profileResponse";
import { isTruthy } from "@vega-core/utils/isTruthy";

export function getInitials(user: ProfileResponse) {
  if (user.firstName) return user.firstName.slice(0, 1);
  else if (user.lastName) return user.lastName.slice(0, 1);
  else return "U";
}

export function getFullName(user: { firstName?: string; lastName?: string }) {
  if (isTruthy(user.firstName) && isTruthy(user.lastName))
    return `${user.firstName} ${user.lastName}`;
  else if (isTruthy(user.firstName)) return user.firstName;
  else if (isTruthy(user.lastName)) return user.lastName;
  else return "user";
}
